import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';

const translationKeys = {
  TITLE: "Defining the Standard in Detection and Sorting",
  ABOUT: "About us",
  ABOUTEV: "About Eagle Vizion",
  PROJECTS_DONE: "Years of innovation",
  HAPPY_CUSTOMER: "Active Continents ",
  P1: "Founded in 2006, Eagle Vizion was built to redefine material identification through precision engineering and intelligent technology. We began in the demanding PET bottle-to-bottle recycling industry, where purity and performance are critical. Today, we serve MRFs, plastics recyclers, C&D processors, mining and aggregate operations, and the food industry — delivering advanced detection and sorting solutions across diverse material streams.",
  P2: "Our systems combine optical technologies, NIR (Near-Infrared) sensing, AI-driven analytics, and intelligent data platforms to go beyond traditional sorting. We don’t just separate materials — we generate actionable insight that improves yield, reduces losses, and drives smarter operational decisions.",
  P3: "Precision Detection. Optimized Sorting. Smarter Operations. Eagle Vizion is not just building machines. We are defining the standard in material intelligence.",
};

const AboutUs = () => {
  const { currentLanguage, translateContent } = useLanguage();
  const [translations, setTranslations] = useState(translationKeys);

  useEffect(() => {
    const translateAll = async () => {
      const keys = Object.keys(translationKeys);
      const newTranslations = {};
      const translationPromises = keys.map(async (key) => {
        try {
          const translated = await translateContent(translationKeys[key]);
          newTranslations[key] = translated || translationKeys[key];
        } catch {
          newTranslations[key] = translationKeys[key];
        }
      });
      await Promise.all(translationPromises);
      setTranslations(newTranslations);
    };
    translateAll();
  }, [currentLanguage, translateContent]);

  return (
    <>
      <section className="about__area pt-120 pb-90">
        <div className="container">
          <div className="row">
            <div className="d-none d-lg-block col-lg-6"></div>
            <div className="col-12 col-lg-6">
              <div className="section__wrapper mb-30">
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px', flexWrap: 'wrap' }}>
                  <span style={{
                    fontStyle: 'italic',
                    color: '#888',
                    fontSize: 'clamp(0.85rem, 0.75rem + 0.3vw, 1rem)',
                    fontWeight: 400,
                    whiteSpace: 'nowrap',
                    borderBottom: '2px solid #2b5baa',
                    paddingBottom: '2px',
                    marginTop: '6px',
                  }}>
                    {translations.ABOUT}
                  </span>
                  <h4 className="section__title" style={{ transition: 'all 0.3s ease', margin: 0 }}>
                    {translations.TITLE}
                  </h4>
                </div>
              </div>
            </div>
          </div>

          {/* Now image aligns with the first paragraph (Eagle …) */}
          <div className="row g-4 align-items-start">
            <div className="col-12 col-lg-6">
              <div className="ab-tab-info mb-30">
                <div className="ab-image w-img">
                  <img src="assets/img/about/about-1.png" alt="" />
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-6">
              <div className="ab-left-content">
                <p className="about__info-quote" style={{ marginBottom: 12, fontWeight: 600, color: '#000' }}>
                  {translations.ABOUTEV}
                </p>
                <p className="about__info-quote" style={{ textAlign: "justify" }}>
                  {translations.P1}
                </p>
                <p className="about__info-quote" style={{ textAlign: 'justify' }}>
                  {translations.P2}
                </p>
                <p className="sm-text mb-45" style={{ textAlign: 'justify', color: '#000' }}>
                  {translations.P3}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUs;